/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Not_Found_BodyInputs */

const en_product_not_found_body = /** @type {(inputs: Product_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It does not exist or you have no access to it. An admin of the space can add you.`)
};

const de_product_not_found_body = /** @type {(inputs: Product_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es existiert nicht oder du hast keinen Zugriff darauf. Eine Person mit Admin-Rechten im Bereich kann dich hinzufügen.`)
};

/**
* | output |
* | --- |
* | "It does not exist or you have no access to it. An admin of the space can add you." |
*
* @param {Product_Not_Found_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const product_not_found_body = /** @type {((inputs?: Product_Not_Found_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Not_Found_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_product_not_found_body(inputs)
	return en_product_not_found_body(inputs)
});